import React, { Fragment } from 'react';
import { FilterIcon } from 'lucide-react';
export interface Rule {
  field: string;
  operator: string;
  value: string;
  logic?: 'AND' | 'OR';
}
interface QualificationRulesProps {
  rules: Rule[];
}
export function QualificationRules({
  rules
}: QualificationRulesProps) {
  return <div className="bg-white rounded-lg p-3 border border-gray-200 shadow-sm" data-id="element-84">
      <div className="flex items-center gap-2 mb-3 pb-2 border-b border-gray-100" data-id="element-85">
        <FilterIcon className="w-3.5 h-3.5 text-blue-600" data-id="element-86" />
        <span className="text-[10px] font-bold text-gray-500 uppercase tracking-wider" data-id="element-87">
          Logic Builder
        </span>
      </div>
      <div className="flex flex-wrap items-center gap-2" data-id="element-88">
        {rules.map((rule, index) => <Fragment key={index} data-id="element-89">
            {index > 0 && <div className="relative px-1 flex items-center justify-center" data-id="element-90">
                <span className="bg-gray-100 px-1.5 py-0.5 rounded text-[9px] font-bold text-gray-500 border border-gray-200" data-id="element-91">
                  {rule.logic || 'AND'}
                </span>
              </div>}
            <div className="flex items-center bg-blue-50 border border-blue-100 rounded-md px-2 py-1.5 text-xs group hover:border-blue-200 transition-colors" data-id="element-92">
              <span className="font-semibold text-blue-800 mr-1.5" data-id="element-93">
                {rule.field}
              </span>
              <span className="text-blue-400 mr-1.5 font-mono" data-id="element-94">
                {rule.operator}
              </span>
              <span className="font-bold text-gray-900 bg-white px-1.5 rounded border border-blue-100 shadow-sm" data-id="element-95">
                {rule.value}
              </span>
            </div>
          </Fragment>)}
      </div>
    </div>;
}